import FileUploader from "@Blobs/Components/FileUploader.vue";
import { Refresh } from '@browser/Browser';
import { generateName } from '@common/Common';
import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { ImportProjectPlansFromSpreadsheetCommandV1 } from '@Quest/Portfolios/Domain/commands-core';
import PortfoliosCommands from '@Quest/Portfolios/Domain/commands-vue-component';
import PortfoliosQueries from '@Quest/Portfolios/Domain/queries-vue-component';
import { ProjectPlansSpreadsheetImportMappingReadModel } from '@Quest/Portfolios/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { PortfolioNavigation, FileUploader } })
export default class ImportProjectPlansPage extends mixins(PortfoliosQueries, PortfoliosCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: ProjectPlansSpreadsheetImportMappingReadModel | null = null;
    file: File | null = null;

    get portfolioId()
    {
        if (!this.rm?.PortfolioId)
        {
            throw new Error('PortfolioId is not defined.');
        }
        return this.rm.PortfolioId;
    }

    loadMappings(blobId: string) 
    {
        this.runSpreadsheetImportMappingQueryV1(this.workspaceId, this.tchProjectId, blobId);
    }

    cancelImport()
    {
        this.rm = null;
        this.file = null;
    }

    handleImportProjectPlansFromSpreadsheetCommand()
    {
        this.invokeImportProjectPlansFromSpreadsheetCommandV1(this.workspaceId, this.portfolioId, this.rm!.BlobId, generateName("Imported plan"));
    }

    mounted()
    {
        document.title = "Import | TransparentChoice";
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "ProjectPlansSpreadsheetImportMappingReadModel")
        {
            this.rm = model as ProjectPlansSpreadsheetImportMappingReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (ImportProjectPlansFromSpreadsheetCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }
}